import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'hooks/redux';
import { getBusiness } from 'pages/Profile/selectors';
import {
  ApplicationStatuses,
  FunderOnboardingStatuses,
} from 'entities/progress';

const OatFiCreditLimit = () => {
  const { t } = useTranslation('dashboard');

  const business = useAppSelector(getBusiness);

  const funderOnboardingStatus = (
    business.funderOnboardingStatusName ?? ''
  ).toLowerCase();

  const isApproved =
    business.applicationStatusTypeCode === ApplicationStatuses.approved;

  if (!business.submittedByPersonsId || business.submittedByPersonsId == 0) {
    return null;
  }

  if (
    funderOnboardingStatus === FunderOnboardingStatuses.pending ||
    funderOnboardingStatus === FunderOnboardingStatuses.approvedNotSigned
  ) {
    return (
      <div className="p-3 w-full bg-gray-100 rounded-md mt-2.5">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-gray-900">
            {t('progress.capital.creditLimit')}
          </p>
          <div className="bg-yellow-100 text-yellow-800 border border-yellow-200 text-xs font-medium px-2 py-0.5 rounded">
            {t('progress.capital.incomplete')}
          </div>
        </div>
      </div>
    );
  }

  if (funderOnboardingStatus === FunderOnboardingStatuses.pendingApproval) {
    return (
      <div className="p-3 w-full bg-gray-100 rounded-md mt-2.5">
        <div className="flex items-start justify-between">
          <div className="mr-3">
            <p className="text-sm font-medium text-gray-900">
              {t('progress.capital.creditLimit')}
            </p>
          </div>
          <div className="bg-blue-100 text-blue-800 border border-blue-200 text-xs font-medium px-2 py-0.5 rounded">
            {t('progress.capital.pending')}
          </div>
        </div>
      </div>
    );
  }

  if (funderOnboardingStatus === FunderOnboardingStatuses.declined) {
    return (
      <div className="p-3 w-full bg-gray-100 rounded-md mt-2.5">
        <div className="flex items-center justify-between">
          <p className="text-sm font-medium text-gray-900">
            {t('progress.capital.creditLimit')}
          </p>
          <div className="bg-red-100 text-red-800 border border-red-200 text-xs font-medium px-2 py-0.5 rounded">
            {t('progress.capital.declined')}
          </div>
        </div>
      </div>
    );
  }

  if (funderOnboardingStatus === FunderOnboardingStatuses.approved) {
    return (
      <div className="p-3 w-full bg-gray-100 rounded-md mt-2.5">
        <div className="flex items-start justify-between">
          <div className="mr-3">
            <p className="text-sm font-medium text-gray-900">
              {t('progress.capital.creditLimit')}
            </p>
            {business.oatFiUnderwritingCreditLimit != null && (
              <p className="text-sm text-gray-600">
                {business.oatFiUnderwritingCreditLimit.toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 2,
                })}{' '}
                USD
              </p>
            )}
          </div>

          <div
            className={`bg-${isApproved ? 'green' : 'blue'}-100 text-${
              isApproved ? 'green' : 'blue'
            }-800 border border-${
              isApproved ? 'green' : 'blue'
            }-200 text-xs font-medium px-2 py-0.5 rounded`}
          >
            {t(`progress.capital.${isApproved ? 'active' : 'approved'}`)}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default OatFiCreditLimit;
